<template>
  <div class="table-page-search-wrapper">
    <a-form-model :model="queryParams" layout="inline" :labelCol="{ style: { flex: '0 0 90px' } }">
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="计划单号" prop="orderNo">
            <a-input v-model="queryParams.orderNo" allowClear placeholder="请输入计划单号" />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="工单号" prop="wipEntityName">
            <a-input v-model="queryParams.wipEntityName" allowClear placeholder="请输入工单号" />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="物料编码" prop="itemCode">
            <a-input v-model="queryParams.itemCode" allowClear placeholder="请输入物料编码" />
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-model-item label="物料名称" prop="itemName">
            <a-input v-model="queryParams.itemName" allowClear placeholder="请输入物料名称" />
          </a-form-model-item>
        </a-col>

        <a-col :md="6" :sm="24">
          <a-form-model-item label="工单状态" prop="workOrderStatus">
            <a-select v-model="queryParams.workOrderStatus" allowClear placeholder="请选择工单状态">
              <a-select-option v-for="item in workOrderStatusOptions" :key="item.lookupCode" :value="item.lookupCode">
                {{ item.lookupValue }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :md="6" :sm="24">
          <a-form-model-item label="排单状态" prop="status">
            <a-select v-model="queryParams.status" allowClear placeholder="请选择排单状态">
              <a-select-option v-for="item in schedulingStatusOptions" :key="item.lookupCode" :value="item.lookupCode">
                {{ item.lookupValue }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="6" :sm="24" class="aj-center-end">
          <span class="table-page-search-submitButtons">
            <a-button @click="handleSearch" type="primary">查询</a-button>
            <a-button @click="resetQuery" class="ml8">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import isNil from 'lodash/isNil'
import { apiLookupDataList } from '@/api/system/lookup/look-up-detail'

export default {
  name: 'SearchForm',
  data () {
    return {
      mainProcessOptions: [],
      workOrderStatusOptions: [],
      schedulingStatusOptions: [],
      queryParams: this.getInitialValue()
    }
  },
  created () {
    this.loadLookupOptions()
  },
  methods: {
    handleSearch () {
      const values = { ...this.queryParams }
      for (const field in values) {
        if (isNil(values[field]) || values[field] === '') {
          delete values[field]
        }
      }
      this.$emit('search', values)
    },
    resetQuery () {
      this.queryParams = this.getInitialValue()
      this.handleSearch()
    },
    getInitialValue () {
      return {
        orderNo: undefined,
        wipEntityName: undefined,
        itemCode: undefined,
        mainProcessCode: undefined,
        itemName: undefined,
        workOrderStatus: undefined,
        status: undefined
      }
    },
    loadLookupOptions () {
      this.getLookupOptions('MES_MAIN_PROCESS', 'mainProcessOptions')
      this.getLookupOptions('MES_JOB_STATUS', 'workOrderStatusOptions')
      this.getLookupOptions('MES_SCHEDULING_STATUS', 'schedulingStatusOptions')
    },
    getLookupOptions (lookupType, target) {
      apiLookupDataList({ lookupType, current: 1, pageSize: 999 }).then(res => {
        this[target] = res.rows || []
      })
    }
  }
}
</script>
